// extracted by mini-css-extract-plugin
export default {"PagingButton":"pagingButton_PagingButton__Ww2Ti"};